import { KudosApiClient } from '@fourthwall/services/dist/KudosApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'
import { decodeHtmlEntities } from '@fourthwall/utils/dist/sanitize'

export const useKudosOrdersQuery = createQueryHook(KudosApiClient.getKudosOrders, {
  queryKey: ['kudosOrders'],
  select: (data) => {
    data.orders = data.orders.map((order) => ({
      ...order,
      message: decodeHtmlEntities(order.message),
      supporter: {
        ...order.supporter,
        fullName: decodeHtmlEntities(order.supporter.fullName),
      },
    }))

    return data
  },
})
